/* unplugin-vue-components disabled */import script from "./ChooseProduct2.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseProduct2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__